import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { ScrollSmoother } from 'gsap/ScrollSmoother';

gsap.registerPlugin(ScrollTrigger);

const BREAK_POINT = 960;

let mm = gsap.matchMedia();

const spanWrapText = (target) => {
  const nodes = [...target.childNodes];
  let returnText = '';

  for (const node of nodes) {
    if (node.nodeType == 3) {
      const text = node.textContent.replace(/\r|\n | [\s\u{3000}]/ug, '');
      const splitText = text.split('');
      for (const char of splitText) {
        returnText += `<span class="first-span"><span>${char}</span></span>`;
      }
    } else {
      returnText += node.outerHTML;
    }
  }
  return returnText;
};



const setItems = () => {

  mm.add(`(min-width: ${BREAK_POINT}px)`, () => {
    gsap.set('.js-fade-up-sp', {
      opacity: 1,
      y: 0,
    });

    gsap.set('.js-fade-up-pc', {
      opacity: 0,
      y: 20,
    });

    const splitElements = [...document.querySelectorAll('.js-animation-title')];
    for (const element of splitElements) {
      element.innerHTML = spanWrapText(element);

      const firstSpan = element.querySelectorAll('.first-span');



      gsap.set(firstSpan, {
        display: 'inline-block',
        overflow: 'hidden',
        lineHeight: 1
      });

      firstSpan.forEach(span => {
        span.span = span.querySelector('span');

        gsap.set(span.span, {
          display: 'block',
          opacity: 0,
          y: '100%',
          skewX: '12deg',
          lineHeight: 1
        });
      });

    }



  });

  mm.add(`(max-width: ${BREAK_POINT - 1}px)`, () => {
    gsap.set('.js-fade-up-pc', {
      opacity: 1,
      y: 0,
    });

    gsap.set('.js-fade-up-sp', {
      opacity: 0,
      y: 20,
    });

    const splitElements = document.querySelectorAll('.js-animation-title');

    splitElements.forEach(element => {
      const spans = element.querySelectorAll('span');

      if (spans) {
        gsap.set(spans, {
          opacity: 1,
          y: 0,
          skewX: 0,
        });
      }

    });

  });
};


const init = () => {

  mm.add(`(min-width: ${BREAK_POINT}px)`, () => {
    const fadeUpItems = document.querySelectorAll('.js-fade-up-pc');

    fadeUpItems.forEach(item => {
      gsap.to(item, {
        opacity: 1,
        y: 0,
        scrollTrigger: {
          trigger: item,
          start: 'top bottom-=15%',
        }
      });
    });

    const splitElements = document.querySelectorAll('.js-animation-title');

    splitElements.forEach(element => {
      const spans = element.querySelectorAll('span');

      gsap.to(spans, {
        opacity: 1,
        y: 0,
        skewX: 0,
        stagger: 0.06,
        scrollTrigger: {
          trigger: element,
          start: 'top bottom-=15%',
        }
      });
    });

  });

  mm.add(`(max-width: ${BREAK_POINT - 1}px)`, () => {
    const fadeUpItems = document.querySelectorAll('.js-fade-up-sp');

    fadeUpItems.forEach(item => {
      gsap.to(item, {
        opacity: 1,
        y: 0,
        scrollTrigger: {
          trigger: item,
          start: 'top bottom-=15%',
        }
      });
    });

  });
};

export { setItems };

export default init;